//* ---------------------------------------
//  Vendors

import 'details-element-polyfill'
import 'focus-visible'
import 'focus-within-polyfill'
import 'node-remove-polyfill'
import 'objectFitPolyfill'
import 'whatwg-fetch'
import 'form-association-polyfill/dist/form-association-polyfill-register-with-shims'

//* ---------------------------------------
//  Class Imports

import { Components } from './components/'
import Component from './lib/component'
import Scroller from './lib/scroller'

//* ---------------------------------------
//  Create RootComponent

export const RootComponent = new Component({
    el: document.body,
    name: 'RootComponent',
    props: (document.body || {}).dataset || {},
    Scroller: new Scroller()
})

//* ---------------------------------------
//  Detect Features like Modernizr

RootComponent
    .addFeatureTest({
        csspointerevents: () => RootComponent.detectCSSProp('pointer-events'),
        csstouchaction: () => RootComponent.detectCSSProp('touch-action'),
        csspositionsticky: () => {
            const div = document.createElement('div')
            div.style.position = 'sticky'

            document.body.appendChild(div)

            const isSticky = window.getComputedStyle(div)
                .position
                .match(/sticky/)

            document.body.removeChild(div)

            return isSticky
        },
        scrollbarwidth: () => {
            const inner = document.createElement('p')
            const outer = document.createElement('div')

            inner.style.width = '100%'
            inner.style.height = '200px'

            outer.className = 'scrollbarwidth-feature-test'
            outer.style.position = 'absolute'
            outer.style.top = '-150px'
            outer.style.left = '-200px'
            outer.style.width = '200px'
            outer.style.height = '150px'
            outer.style.visibility = 'hidden'
            outer.style.overflow = 'scroll'

            outer.appendChild(inner)
            document.body.appendChild(outer)

            const width = outer.offsetWidth - inner.clientWidth
            document.body.removeChild(outer)

            document.documentElement
                .style.setProperty('--scrollbar-width', `${width}px`)

            return width
        }
    })
    .addFeaturesToClassName()

//* ---------------------------------------
//  RootComponent on Scroll Toggling

RootComponent
    .on('scroll:disable', () => {
        if (document.documentElement.getAttribute('data-scrolly-restore'))
            return

        const scrollY = RootComponent.Scroller.state
            .get('scrollY')

        document.documentElement
            .setAttribute('data-scrolly-restore', scrollY)

        document.documentElement
            .classList.add('overflow-hidden')
    })

RootComponent
    .on('scroll:enable', () => {
        document.documentElement
            .classList.remove('overflow-hidden')

        if (!document.documentElement.getAttribute('data-scrolly-restore'))
            return

        document.documentElement
            .removeAttribute('data-scrolly-restore')

        const scrollY = Number(document.documentElement
            .getAttribute('data-scrolly-restore') || '0') || 0

        if (scrollY)
            RootComponent.Scroller
                .scrollTo({ x: 0, y: scrollY }, 0)
    })

//* ---------------------------------------
//  RootComponent on Resize

RootComponent
    .on('resize', () => {
        if (RootComponent.props.resizing !== 'true')
            RootComponent.props.resizing = true

        if (document.documentElement.getAttribute('data-scrollY-restore'))
            document.documentElement
                .setAttribute('data-scrollY-restore',
                    RootComponent.Scroller.state.get('scrollY'))

        window.objectFitPolyfill()
    })

RootComponent
    .on('resize:debounced', () =>
        RootComponent.el.removeAttribute('data-resizing'))

//* ---------------------------------------
//  RootComponent on Render

RootComponent
    .on('render', (e) => Promise
        .resolve(Object.keys(Components)
            .filter(key => 'selector' in Components[key]
                && typeof Components[key] === 'function'
                && RootComponent.el
                && RootComponent.el.querySelector(Components[key].selector()))
            .forEach(key => Array.from(document
                .querySelectorAll(`${
                    Components[key].selector()}:not([data-rendered])`))
                .filter(el => !el.getAttribute('data-rendered'))
                .forEach(el => Promise
                    .resolve(new Components[key]({
                        el: el,
                        props: el.dataset
                    })))))
        .then(() => window.objectFitPolyfill()))
    .emit('render')

//* ---------------------------------------
//  RootComponent El on Focus In

RootComponent.el
    .addEventListener('focusin', (e) => {
        // TODO: Ensure elements are in view on focus
    })

//* ---------------------------------------
//  RootComponent El on DOM changes

if (('MutationObserver' in window))
    (new window.MutationObserver(() => RootComponent.emit('render')))
        .observe(RootComponent.el, {
            childList: true,
            subtree: true
        })
